import { ArrowUpRight, ArrowRight } from "lucide-react";
import { SectionHeading, Reveal } from "@/components/Reveal";
import { scrollToSection } from "@/lib/site";

const INDUSTRIES = [
  {
    name: "Courier Companies",
    desc: "Subcontracted last-mile, regional linehaul and overflow capacity for national courier networks.",
  },
  {
    name: "E-Commerce Businesses",
    desc: "Parcel delivery capacity for online stores — daily order runs, peak season and same-day surges.",
  },
  {
    name: "Retailers",
    desc: "Store replenishment and distribution runs between DCs, branches and retail doors.",
  },
  {
    name: "Warehouses & Distributors",
    desc: "Shuttle runs, hub-to-store transfers and scheduled route contracts out of your distribution centres.",
  },
  {
    name: "Corporate Businesses",
    desc: "Contracted delivery capacity for inter-branch moves, documents and recurring logistics needs.",
  },
];

export const Industries = () => (
  <section id="industries" className="scroll-mt-24 bg-[#0D1424] py-20 md:py-28" data-testid="industries-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="Industries Served"
            title="Built to plug into your operation."
            intro="We contract directly with operations and procurement teams — not once-off consumer bookings. If your business moves parcels, we move them."
          />
          <Reveal delay={0.2}>
            <button
              onClick={() => scrollToSection("enquiry")}
              data-testid="industries-cta-btn"
              className="group mt-8 inline-flex items-center gap-2 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-[#FF6B00] transition-colors hover:text-[#E05E00]"
            >
              Request contract terms
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Reveal>
            <div className="border-t border-white/10">
              {INDUSTRIES.map((ind, i) => (
                <div
                  key={ind.name}
                  data-testid={`industry-row-${i + 1}`}
                  className="group grid grid-cols-[auto_1fr_auto] items-center gap-4 border-b border-white/10 px-2 py-5 transition-colors duration-300 hover:bg-white/[0.03] md:gap-6 md:px-4 md:py-6"
                >
                  <span className="font-mono text-xs font-semibold tracking-[0.2em] text-[#FF6B00]">
                    0{i + 1}
                  </span>
                  <div>
                    <h3 className="font-display text-lg font-extrabold uppercase tracking-tight text-white md:text-2xl">
                      {ind.name}
                    </h3>
                    <p className="mt-1 max-w-xl text-sm leading-relaxed text-slate-400">
                      {ind.desc}
                    </p>
                  </div>
                  <ArrowUpRight className="h-5 w-5 shrink-0 text-slate-600 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#FF6B00]" />
                </div>
              ))}

              <a
                href="#enquiry"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("enquiry");
                }}
                data-testid="industry-row-cta"
                className="group flex items-center justify-between gap-4 border-b border-[#FF6B00]/40 bg-[#FF6B00]/[0.06] px-2 py-5 transition-colors duration-300 hover:bg-[#FF6B00]/[0.12] md:px-4 md:py-6"
              >
                <div className="flex items-center gap-4 md:gap-6">
                  <span className="font-mono text-xs font-semibold tracking-[0.2em] text-[#FF6B00]">
                    06
                  </span>
                  <h3 className="font-display text-lg font-extrabold uppercase tracking-tight text-[#FF6B00] md:text-2xl">
                    Your operation next
                  </h3>
                </div>
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400 transition-colors group-hover:text-white">
                  Talk procurement
                  <ArrowUpRight className="ml-2 inline h-4 w-4 transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
                </span>
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
